<template>
    <input
      type="text"
      :value="value"
      class="border-none focus:outline-none w-[40ch]"
      ref="editInput"
      :maxlength="Number(maxlength)"
    />
  </template>
  <script>

  export default {
    props: {
      value: String,
      maxlength: Number
    },
    computed: {
    },
    methods: {
    
    },
    mounted() {
      this.$refs.editInput.focus();

    }
  };
  </script>